import React, { useMemo } from 'react';
import './indicacionDetalle.scss';
import { Grid } from '@mui/material';
import DataGridGenerico from '../../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../../components/dataGrid/columnHelpers';
import { CustomChip } from '../../../../components/chip/Chip';

export const IndicacionDetalleIndicacionSolicitada = ({ indicacion, esMedico }) => {

    const ESTADO_PENDIENTE = 1;
    const ESTADO_APROBADO = 2;
    const ESTADO_NUEVO_CONTRATO = 3;
    const ESTADO_RECHAZADO = 4;

    const getChipEstado = (estado) => {
        switch (estado) {
            case ESTADO_PENDIENTE:
                return (
                    <CustomChip label='Pendiente' isYellow title='Pendiente' />
                )
            case ESTADO_APROBADO:
                return (
                    <CustomChip label='Aprobado' isGreen title='Aprobado' />
                )
            case ESTADO_NUEVO_CONTRATO:
                return (
                    <CustomChip label='Nuevo Contrato' isGreen title='Nuevo Contrato' />
                )
            case ESTADO_RECHAZADO:
                return (
                    <CustomChip label='Rechazado' isRed title='Rechazado' />
                )
            default: return;
        }
    }

    const initialColumns = (esMedico) ? [
        {
            field: 'nombre',
            headerName: 'Nombre',
            flex: 0.2
        },
        {
            field: 'cantidadDiaria',
            headerName: 'Cantidad diaria',
            flex: 0.2
        },
        {
            field: 'unidad',
            headerName: 'Unidad',
            flex: 0.08
        }
    ] : [{
        field: 'nombre',
        headerName: 'Nombre',
        flex: 0.5
    },
    {
        field: 'presentacion',
        headerName: 'Presentación',
        flex: 0.25,
        valueGetter: (_, row) => {
            return row.cantidadPresentacion + ' ' + row.unidad;
        }
    },
    {
        field: 'cantidadDiaria',
        headerName: 'Cantidad diaria',
        flex: 0.25
    },
    {
        field: 'proporcionDiaria',
        headerName: 'Proporción diaria',
        flex: 0.2,
        valueGetter: (proporcionDiaria) => {
            return proporcionDiaria + ' %';
        }
    },
    {
        field: 'costoUnidad',
        headerName: 'Costo unitario',
        flex: 0.2,
        valueGetter: (costoUnidad) => {
            return '$ ' + costoUnidad;
        }
    },
    {
        field: 'costoTotal',
        headerName: 'Costo total',
        flex: 0.2,
        valueGetter: (costoTotal) => {
            return '$ ' + costoTotal;
        }
    },
    ];

    const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns, true), [indicacion?.insumos]);

    return (
        <Grid container className='contrato-card-white'>
            <Grid size={{ xs: 12 }}>
                <div className='section-title'>Indicación solicitada</div>
            </Grid>
            <Grid container spacing={2} size={{ xs: 12 }}>
                <Grid size={{ xs: 6, md: 2 }}>
                    <div className='contrato-card-label'>Número</div>
                    <div>{indicacion?.idIndicacionAprobacion}</div>
                </Grid>
                <Grid size={{ xs: 12, md: 3 }}>
                    <div className='contrato-card-label'>Período</div>
                    <div>{indicacion?.periodoSolicitud}</div>
                </Grid>
                {
                    !esMedico &&
                    <Grid size={{ xs: 6, md: 2 }}>
                        <div className='contrato-card-label'>Proporción diaria</div>
                        <div>{(indicacion?.proporcionDiariaSolicitud != '') ? indicacion?.proporcionDiariaSolicitud + ' %' : '-'}</div>
                    </Grid>
                }
            </Grid>
            <Grid container spacing={2} sx={{ marginTop: '5px' }} size={{ xs: 12 }}>
                <Grid size={{ xs: 12, md: 3 }}>
                    <div className='contrato-card-label'>Solicitante</div>
                    <div>{indicacion?.solicitante}</div>
                </Grid>
                <Grid size={{ xs: 12, md: 9 }}>
                    <div className='contrato-card-label'>Observación Solicitante</div>
                    <div>{indicacion?.observacionSolicitante}</div>
                </Grid>
                {
                    esMedico &&
                    <>
                        <Grid size={{ xs: 12, md: 3 }}>
                            <div className='contrato-card-label'>Respuesta Comercial</div>
                            <div>{(indicacion?.idEstadoComercial != '') ? getChipEstado(indicacion?.idEstadoComercial) : '-'}</div>
                        </Grid>
                        <Grid size={{ xs: 12, md: 9 }}>
                            <div className='contrato-card-label'>Observación Comercial</div>
                            <div>{(indicacion?.observacionComercial != '') ? indicacion?.observacionComercial : '-'}</div>
                        </Grid>
                    </>
                }
                {
                    !esMedico &&
                    <>
                        <Grid size={{ xs: 12, md: 3 }}>
                            <div className='contrato-card-label'>Respuesta Médica</div>
                            <div>{(indicacion?.idEstadoMedico != '') ? getChipEstado(indicacion?.idEstadoMedico) : '-'}</div>
                        </Grid>
                        <Grid size={{ xs: 12, md: 9 }}>
                            <div className='contrato-card-label'>Observación Médica</div>
                            <div>{(indicacion?.observacionMedico != '') ? indicacion?.observacionMedico : '-'}</div>
                        </Grid>
                    </>
                }

                <Grid size={{ xs: 6, md: 12 }}>
                    <div className='contrato-card-label'>Detalle de indicación</div>
                    <DataGridGenerico
                        columns={columns}
                        rows={indicacion?.insumos}
                        toolbar={false}
                        hideFooter={true}
                        key={indicacion?.idIndicacionAprobacion}
                    />
                </Grid>
            </Grid>
        </Grid>
    )
}